module.exports = __webpack_public_path__ + "img/AWSD.67e79680.png";